import { render, staticRenderFns } from "./ActivityTypes.vue?vue&type=template&id=1218b9e9"
import script from "./ActivityTypes.vue?vue&type=script&lang=js"
export * from "./ActivityTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports